<template>
  <div class="skill">
    <div class="base">
      <img class="icon" alt="" :src="dataSource.icon.value" />
      <div class="info">
        <div class="name">
          <span>技能：{{ dataSource.name.value }}</span>
          <span class="video-btn" @click="openVideo">
            <img src="@/assets/zs_imgs/video-icon.png" alt="" />
          </span>
          <!-- 显示技能视频 -->
          <el-dialog
            title=""
            fullscreen
            append-to-body
            custom-class="video-dialog"
            :visible.sync="videoVisible"
            :after-close="closeVideo"
          >
            <div class="video-container">
              <video :src="dataSource.video.value" controls autoplay muted></video>
            </div>
          </el-dialog>
        </div>
        <div class="attr">
          <span class="item">消耗的SP：{{ dataSource.sp.value }}个</span>
          <span class="item">冷却时间：{{ dataSource.cd.value }}回合</span>
        </div>
      </div>
    </div>
    <div class="desc">
      <span v-html="highlightNumbers(dataSource.desc.value)"></span>
    </div>
    <div class="effect">
      <div>
        <span>{{ dataSource.ability1.name.value }}</span
        >：<span>{{ dataSource.ability1.desc.value }}</span>
      </div>
      <div>
        <span>{{ dataSource.ability2.name.value }}</span
        >：<span>{{ dataSource.ability2.desc.value }}</span>
      </div>
    </div>
    <div class="other-attr">
      <div class="left">
        <div class="item">
          <span>{{ dataSource.attr1.name.value }}</span>
          <img class="icon" alt="" :src="dataSource.attr1.icon.value" />
        </div>
        <div class="item">
          <span>{{ dataSource.attr2.name.value }}</span>
          <img class="icon" alt="" :src="dataSource.attr2.icon.value" />
        </div>
        <div class="item">
          <span>{{ dataSource.attr3.name.value }}</span>
          <img class="icon" alt="" :src="dataSource.attr3.icon.value" />
        </div>
      </div>
      <div class="right">
        <div class="more-btn" @click="handleOpenMore">强化效果</div>
        <!-- 显示强化效果 -->
        <el-dialog
          title=""
          custom-class="more-drawer"
          :visible.sync="drawer"
          :after-close="handleCloseMore"
          width="800px"
          append-to-body
        >
          <div class="more-content">
            <div class="header">
              <div class="title">技能潜力＆强化效果</div>
              <div class="close">
                <img src="@/assets/zs_imgs/close-icon.png" alt="" @click="handleCloseMore" />
              </div>
            </div>
            <div class="content">
              <div class="potential" v-if="!isEmptyPotential">
                <template v-for="key in Object.keys(dataSource.potential)">
                  <div
                    class="item"
                    :key="key"
                    v-if="dataSource.potential[key].icon.hasValue && dataSource.potential[key].icon.value"
                  >
                    <img class="icon" :src="dataSource.potential[key].icon.value" alt="" />
                    <span class="desc" v-if="dataSource.potential[key].desc.value">{{
                      dataSource.potential[key].desc.value
                    }}</span>
                    <img class="desc-icon" v-else :src="dataSource.potential[key].iconDesc.value" alt="" />
                  </div>
                </template>
              </div>
              <div class="list">
                <template v-for="key in Object.keys(dataSource.upgrade)">
                  <div class="item" :key="key" v-if="dataSource.upgrade[key].name.hasValue">
                    <div class="title">
                      <span>
                        {{ dataSource.upgrade[key].name.value }}
                      </span>
                      <span>
                        SP<span style="color: #ef7f7f;">{{ dataSource.upgrade[key].sp.value }}</span> </span
                      >,
                      <span>
                        CD<span style="color: #ef7f7f;">{{ dataSource.upgrade[key].cd.value }}</span>
                      </span>
                      <img class="icon" alt="" :src="dataSource.upgrade[key].icon.value" />
                    </div>
                    <div class="desc">
                      <span v-html="highlightNumbers(dataSource.upgrade[key].desc.value)"></span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  inject: {
    refreshMap: {
      default: () => {}
    }
  },
  data() {
    return {
      drawer: false,
      videoVisible: false
    };
  },
  computed: {
    isEmptyPotential() {
      return !Object.keys(this.dataSource.potential).some(key => {
        return this.dataSource.potential[key].icon.hasValue && this.dataSource.potential[key].icon.value;
      });
    }
  },
  methods: {
    handleOpenMore() {
      this.drawer = true;
      this.$nextTick(() => {
        if (this.refreshMap) this.refreshMap();
      });
    },
    handleCloseMore() {
      this.drawer = false;
    },
    openVideo() {
      this.videoVisible = true;
    },
    closeVideo() {
      this.videoVisible = false;
    },
    highlightNumbers(str) {
      return str.replace(/(\d+\.?\d*%?)/g, `<span style="color: #ef7f7f;">$1</span>`);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .video-dialog {
  background-color: rgba(0, 0, 0, 0.9);
  .el-dialog__header {
    padding: 0;
    position: relative;
    margin: 0 auto;
    width: 1000px;
    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .video-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
    video {
      width: 960px;
    }
  }
}
.skill {
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  .base {
    display: flex;
    align-items: center;
    height: 48px;
    margin-bottom: 12px;
    .icon {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      border-radius: 24px;
      margin-right: 12px;
    }

    .info {
      flex: 1;
      .name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 15px;

        .video-btn {
          display: inline-block;
          width: 27px;
          height: 27px;
          background: rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 17px;
            height: 15px;
          }
        }
      }

      .attr {
        display: flex;
        gap: 8px;
        .item {
          padding: 3px 10px;
          background: rgba(255, 230, 44, 0.1);
          border-radius: 57px 57px 57px 57px;
          font-weight: 400;
          font-size: 12px;
          color: #ffe19a;
        }
      }
    }
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
  }

  .effect {
    padding: 26px 0 18px;
    div {
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 14px;
      margin-bottom: 13px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .other-attr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    .left {
      display: flex;
      gap: 21px;
    }
    .item {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 11px;
      color: #999999;
      gap: 5px;
      .icon {
        width: 30px;
        height: 30px;
      }
    }

    .more-btn {
      height: 20px;
      background: rgba(123, 213, 255, 0.3);
      border-radius: 10px;
      font-weight: 400;
      font-size: 11px;
      color: #82fff8;
      text-align: center;
      cursor: pointer;
      padding: 4px 10px;
      display: flex;
      align-items: center;
    }
  }
}

/deep/ .more-drawer {
  background: transparent;
  box-shadow: none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
  .more-content {
    position: relative;
    z-index: 0;
    height: 100%;
    background: url("~@/assets/zs_imgs/dialog-bg.png");
    background-size: 100% 100%;
    padding: 60px 17px 16px 21px;
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      content: "";
      display: block;
      width: 100%;
      height: 100px;
      overflow: hidden;
      background: url("~@/assets/zs_imgs/dialog-bg.png") no-repeat;
      background-size: 100%;
    }

    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      content: "";
      display: block;
      width: 100%;
      height: 0;
      overflow: hidden;
      background: url("~@/assets/zs_imgs/dialog-bg.png") no-repeat;
      background-size: 100%;
      background-position: 0 0;
      transform: rotateX(180deg);
    }
    .header {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      padding: 24px 10px 24px;
      .title {
        font-weight: 400;
        font-size: 16px;
        color: #fffefe;
        background: url("~@/assets/zs_imgs/dialog-title-bg.png") no-repeat;
        background-size: 194px 38px;
        width: 194px;
        height: 38px;
        line-height: 38px;
        padding-left: 22px;
      }

      .close {
        position: absolute;
        right: 22px;
        top: 30px;
        width: 18px;
        height: 18px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }

    .content {
      position: relative;
      z-index: 2;
      padding: 25px 12px 0;
      .potential {
        border-bottom: 1px solid rgba(255, 255, 255, 0.04);
        .item {
          display: flex;
          gap: 8px;
          align-items: center;
          margin-bottom: 19px;
          .icon {
            width: 24px;
            height: 24px;
            background: #222337;
            border-radius: 4px;
            border: 1px solid #656f74;
          }
          .desc {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
          .desc-icon {
            width: 30px;
            height: 30px;
            border-radius: 4px;
          }
        }
      }
      .list {
        .item {
          padding: 13px 0 21px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.04);
          .title {
            display: flex;
            align-items: flex-end;
            gap: 11px;
            font-weight: 400;
            font-size: 14px;
            color: #ffbc52;
            line-height: 16px;
            margin-bottom: 10px;
            .icon {
              width: 30px;
              height: 30px;
              align-self: center;
            }
          }

          .desc {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>
